<div [style.width]="percentBar" class="progress-bar-container-line"></div>

